<!-- <div class="pan-wrap"> -->
  <!-- <div class="cus-row"> -->
    <!-- <div class="col-3 form-group"> -->
      <label class="form-label">Enter PAN number<span class="mandatory">*</span></label>
      <form [formGroup]="formGroup" class="input-with-icon">
        <span class="input-icon"><div *ngIf="showLoader" class="  loader"></div><img  *ngIf="isValidPan && formGroup.valid " src="assets/images/icons/verified_tick.svg" alt="Icon" ></span>
        <input class="cus-input" type="text" 
        pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}" 
        maxlength="10"
        placeholder="For example: ABCDExxxxR"
        appPanValidatior
        (input)="onPanNumberInput($event)"
        formControlName="panNumber"
        [readOnly]="isValidPan || showLoader"
         />
         
      </form>
      <div class="error-with-number">
        <span *ngIf="!isValidPan" class="cus-input error">{{errorMsg}}</span> 
        <span *ngIf="isValidPan" class="cus-input error"></span> 
        <span class="_end">{{panLenth}}/{{defaultLength}}</span>

      </div>
    <!-- </div> -->
  <!-- </div> -->
  <!-- <div class="page-action"> -->
    <!-- <button class="btn-primary"  [disabled]="!isValidPan || formGroup.invalid " (click)="submitPanDetail()">Continue</button> -->
  <!-- </div> -->
<!-- </div> -->

